/* 🤖 this file was generated by svg-to-ts */
export const matIconSolarPower: {
  name: 'solar-power';
  data: string;
} = {
  name: 'solar-power',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 12H4L2 22h20l-2-10zm-1.64 2 .4 2H13v-2h5.36zM11 14v2H5.24l.4-2H11zm-6.16 4H11v2H4.44l.4-2zM13 20v-2h6.16l.4 2H13zM11 8h2v3h-2zm4.764-.795 1.415-1.414L19.3 7.912l-1.414 1.414zm-11.059.708L6.826 5.79 8.24 7.206 6.12 9.327zM3 2h3v2H3zm15 0h3v2h-3zm-6 5c2.76 0 5-2.24 5-5h-2c0 1.65-1.35 3-3 3S9 3.65 9 2H7c0 2.76 2.24 5 5 5z"/></svg>`
};
